import React from 'react';
import PropTypes from 'prop-types';
import { logToKibanna } from '../src/service/logService';
import { InHomeUtils } from './util/inhomeUtils';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };

  }

  static getDerivedStateFromError(error) {
    return null;
  }

  componentDidCatch(error, errorInfo) {
    const isCritical = this.isCriticalError(error);

    if(isCritical){
      console.error("[CRITICAL]:", error);
      this.setState({hasError: true, errorMessage: error.message, errorStack: error.stack})
      try{
        this.fiosReferralLogtoKibanna();
      }catch(err){
        console.warn("Function Fail", err)
      }
    }else{
      console.warn("[Non-Critical]:", error)
      try{
        this.fiosReferralLogtoKibanna();
      }catch(err){
        console.warn("Function Fail", err)
      }
    }

    if(!isCritical){
      this.setState({ hasError: false })
    }
  }

  isCriticalError(error) {
    if(error?.message?.includes("_detector")) return false;
    if(error?.message?.includes("Cannot read properties of undefined")) return true;
    if(error.name === "TypeError") return true;
    return false
  }

  fiosReferralLogtoKibanna = () => {
    const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
    let logDetails = sessionStorage.getItem('logDetails');
    const orderLoc = sessionStorage.getItem('orderLoc');
    const fiosReferralMON = sessionStorage.getItem('fiosReferralMON');
    const now = Date.now();
    if (orderLoc && fiosReferralMON) {
      logDetails = `${now}:${orderLoc}:${fiosReferralMON}`;
    }

    try {
      if (fiosReferral === "true" && !window.location.href.includes("localhost")) {         
        logToKibanna(`Fios:Retail:ErrorLogId:${logDetails}`);
        if (this.state.errorMessage && this.state.errorStack) {
          logToKibanna(`Fios:Retail:Error:${fiosReferralMON}:${this.state.errorMessage?.toString()}:${this.state.errorStack.toString()}`, "INFO");
        } else if (this.state.errorMessage) {
          logToKibanna(`Fios:Retail:Error:${fiosReferralMON}:${this.state.errorMessage?.toString()}:${this.state.errorStack.toString()}`, "INFO");
        } else {
          logToKibanna(`Fios:Retail:Error:${fiosReferralMON}:Error details not available`, "INFO");
        }
      } else if (fiosReferral === "true" && window.location.href.includes("localhost")) {
        console.log(`Fios:Retail:${logDetails}`);
        if (this.state.errorMessage && this.state.errorStack) {
          console.log(`Fios:Retail:Error:${fiosReferralMON}:${this.state.errorMessage?.toString()}:${this.state.errorStack.toString()}`);
        } else if (this.state.errorMessage) {
          console.log(`Fios:Retail:Error:${fiosReferralMON}:${this.state.errorMessage?.toString()}:${this.state.errorStack.toString()}`);
        } else {
          console.log(`Fios:Retail:Error:${fiosReferralMON}:Error details not available`);
        }
  
      }
    } catch(error) {
      console.log("Error while logging to Kibanna", error);
    }  
      
  }

  handleReset = ()=>{
    this.setState({hasError:false,errorMessage:"",errorStack:""});
    InHomeUtils.exitFiosReferral();  
  };

  render() {
    let logDetails = sessionStorage.getItem('logDetails');
    const orderLoc = sessionStorage.getItem('orderLoc');
    const fiosReferralMON = sessionStorage.getItem('fiosReferralMON');
    if (!logDetails || logDetails === "") {
      logDetails = `logId:${Date.now()}:${orderLoc}:${fiosReferralMON}`;
    }
        
    const lowerEnv = window.location.hostname.includes('nte1');

    if (this.state.hasError && !lowerEnv) {
      return (
        <div style={{
          padding: '20px',  
          color: '#000000', fontFamily: 'Arial , sans-serif',
          
        }}>
          <div  style = {{display:"flex",flexDirection:"column",justifyContent:"center",
            alignItems:"center",textAlign:"center",fontFamily:"Arial,sans-serif",
            backgroundColor:"#f8f9fa",color:"#333",padding:"20px"
          }}>
            <h1 style={{ fontSize: '28px', fontWeight: "bold", marginBottom:"12px", color:"#000000"
             }}> Oops ! Something went wrong.</h1>
            <h3 style = {{fontSize:"23px",fontWeight:"normal",marginBottom:"17px",color:"#000000"}}>{logDetails}</h3>
            <h6 style = {{fontSize:"18px",fontWeight:"normal",marginBottom:"20px",color:"#000000"}}>Please retry again</h6>
            
            <button onClick={() => { this.handleReset() }}
                style={{
                  padding: "12px 20px", fontSize: "16px", color: "white",
                  backgroundColor: "#000000", border: "none", borderRadius: "5px",
                  cursor: "pointer"
                }}>Try Again</button>
          </div>
         

        </div>
      );
    } else if (this.state.hasError && lowerEnv) {
      return (
        <div style={{
          padding: '20px',  
          color: '#000000', fontFamily: 'Arial , sans-serif',
          
        }}>
          <div  style = {{display:"flex",flexDirection:"column",justifyContent:"center",
            alignItems:"center",textAlign:"center",fontFamily:"Arial,sans-serif",
            backgroundColor:"#f8f9fa",color:"#333",padding:"20px"
          }}>
            <h1 style={{ fontSize: '28px', fontWeight: "bold", marginBottom:"12px", color:"#000000"
             }}> Oops ! Something went wrong.</h1>
            <h3 style = {{fontSize:"23px",fontWeight:"normal",marginBottom:"17px",color:"#000000"}}>{logDetails}</h3>
            <h6 style = {{fontSize:"18px",fontWeight:"normal",marginBottom:"20px",color:"#000000"}}>Please retry again</h6>
            
            <button onClick={() => { this.handleReset() }}
                style={{
                  padding: "12px 20px", fontSize: "16px", color: "white",
                  backgroundColor: "#000000", border: "none", borderRadius: "5px",
                  cursor: "pointer"
                }}>Try Again</button>
          </div>
          <div >
          <h1 style={{ fontSize: '28px', fontWeight: "bold", marginBottom:"12px", color:"#000000"
             }}>Log output for NTE1</h1>
              <p style={{ fontSize: "18px" }}>{this?.state?.errorMessage?.toString()}</p>
              <p style={{ fontSize: "18px" }}>{this?.state?.error?.message?.toString()}</p>
              <br></br>
              <pre style={{
                backgroundColor: '#ffebeb', padding: "10px", borderRadius: "5px",
                whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: "14px"
              }}>
                {this?.state?.errorStack}</pre><br></br>
              <pre style={{
                backgroundColor: '#ffebeb', padding: "10px", borderRadius: "5px",
                whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: "14px"
              }}>
                {this?.state?.errorInfo?.componentStack}</pre>
              {this.state.errorInfo}
        </div>
      </div>

      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};
